export default __webpack_public_path__ + "static/media/unpin.4e6c3fb0.svg";